import { render, staticRenderFns } from "./DisplaySettingsPlannings.vue?vue&type=template&id=2c47888c&scoped=true&"
import script from "./DisplaySettingsPlannings.vue?vue&type=script&lang=js&"
export * from "./DisplaySettingsPlannings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c47888c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c47888c')) {
      api.createRecord('2c47888c', component.options)
    } else {
      api.reload('2c47888c', component.options)
    }
    module.hot.accept("./DisplaySettingsPlannings.vue?vue&type=template&id=2c47888c&scoped=true&", function () {
      api.rerender('2c47888c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Plannings/DisplaySettingsPlannings.vue"
export default component.exports